module.exports = __webpack_public_path__ + "img/shareAvatar.b37bd6fb.jpg";